import { render } from "./Tabs.vue?vue&type=template&id=0eb7ad04&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=0eb7ad04&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0eb7ad04"

export default script